export function readTableFilterValue(
  filters: Record<string, unknown> | null | undefined,
  key: string,
) {
  const raw = filters?.[key];
  if (!raw || !Array.isArray(raw) || raw.length === 0) return undefined;
  const value = raw[0];
  if (value == null) return undefined;
  return String(value);
}
